import type { EndpointDef } from '@skynet/data-helpers';

/**
 * Central endpoint definitions — single source of truth for the DEX Agent API.
 *
 * Drives the enhanced API, hook re-exports and MSW mock factories.
 */
export const DEX_AGENT_API_ENDPOINTS = {
  chatAgent: {
    generated: 'apiControllerAgentChat',
    method: 'post',
    path: '/web/agent/chat',
  },
} as const satisfies Record<string, EndpointDef>;

export type DexAgentEndpointName = keyof typeof DEX_AGENT_API_ENDPOINTS;
